<app-modal
  [title]="'EC Terminal action' | trans:'ec-terminal-action-logs-modal/title.Text'"
  maxWidth="600px"
  [compact]="true"
>
  <ng-container modal-precontent>
    <div class="d-flex align-items-center justify-content-center gap-8 p1 m-y-8" [class.d-none]="!data">
      <p>
        <b>{{ 'Amount:' | trans:'ec-terminal-action-logs-modal/amount.Label' }}</b>
      </p>

      <p>
        {{ data ? (data | numberToCurrency) : null }} {{ languageConfig.currency.short }}
      </p>
    </div>
  </ng-container>

  <ng-template>
    <table class="base full-width wrap">
      <tbody>
        @for (l of cardActionLogs; track l.timestamp) {
          <tr>
            <td>
              <div class="d-flex align-items-center gap-12">
              <span>
                {{ l.timestamp | date:'HH:mm:ss' }}
              </span>
                <span
                  class="status d-block {{ l.type === cardActionLogTypes.Error ? 'c-bg-nok-500' : l.type === cardActionLogTypes.Success ? 'c-bg-ok-500' : 'c-bg-blue-500' }}"
                ></span>
                <p
                  class="fw-semibold {{ l.type === cardActionLogTypes.Error ? 'c-t-nok-500' : l.type === cardActionLogTypes.Success ? 'c-t-ok-500' : null }}"
                >{{ l.message }}</p>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-space-between align-items-center">
      <div class="d-flex gap-16">
        @if (cardActionStatus === cardActionLogTypes.Error) {
          <p class="p1 c-t-nok-500 fw-semibold">
            {{ 'Operation failed!' | trans:'ec-terminal-action-logs-modal/status.Error' }}
          </p>
        }

        @if (cardActionStatus === cardActionLogTypes.Success) {
          <p class="p1 c-t-ok-500 fw-semibold">
            {{ 'Operation successful!' | trans:'ec-terminal-action-logs-modal/status.Success' }}
          </p>
        }

        @if ((cardActionStatus === cardActionLogTypes.Warning || cardActionStatus === cardActionLogTypes.Info || !cardActionStatus) && !isFinished) {
          <p class="p1 fw-semibold">
            {{ 'Operation Processing...' | trans:'ec-terminal-action-logs-modal/status.Processing' }}
          </p>
        }

        @if (isFinished && cardActionStatus !== cardActionLogTypes.Error && cardActionStatus !== cardActionLogTypes.Success) {
          <p class="p1 fw-semibold">
            {{ 'Operation Completed' | trans:'ec-terminal-action-logs-modal/status.Completed' }}
          </p>
        }
      </div>

      <div class="d-flex gap-16">
        <button
          class="button button--md button--primary-ghost text-uppercase"
          (click)="close()"
          [disabled]="!isFinished"
        >
          {{ 'Close' | trans:'ec-terminal-action-logs-modal/cancel.Button' }}
        </button>
      </div>
    </div>
  </ng-container>
</app-modal>
